export default __webpack_public_path__ + "static/media/icono_fb.01071206.svg";